/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface PreviewCarrierMeetingRequest
 */
export interface PreviewCarrierMeetingRequest {
  /**
   *
   * @type {string}
   * @memberof PreviewCarrierMeetingRequest
   */
  carrierIdentifier: string;
  /**
   *
   * @type {string}
   * @memberof PreviewCarrierMeetingRequest
   */
  jamieMeetingId: string;
}

/**
 * Check if a given object implements the PreviewCarrierMeetingRequest interface.
 */
export function instanceOfPreviewCarrierMeetingRequest(
  value: object,
): value is PreviewCarrierMeetingRequest {
  if (
    !("carrierIdentifier" in value) ||
    value["carrierIdentifier"] === undefined
  )
    return false;
  if (!("jamieMeetingId" in value) || value["jamieMeetingId"] === undefined)
    return false;
  return true;
}

export function PreviewCarrierMeetingRequestFromJSON(
  json: any,
): PreviewCarrierMeetingRequest {
  return PreviewCarrierMeetingRequestFromJSONTyped(json, false);
}

export function PreviewCarrierMeetingRequestFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): PreviewCarrierMeetingRequest {
  if (json == null) {
    return json;
  }
  return {
    carrierIdentifier: json["carrierIdentifier"],
    jamieMeetingId: json["jamieMeetingId"],
  };
}

export function PreviewCarrierMeetingRequestToJSON(
  json: any,
): PreviewCarrierMeetingRequest {
  return PreviewCarrierMeetingRequestToJSONTyped(json, false);
}

export function PreviewCarrierMeetingRequestToJSONTyped(
  value?: PreviewCarrierMeetingRequest | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    carrierIdentifier: value["carrierIdentifier"],
    jamieMeetingId: value["jamieMeetingId"],
  };
}
